"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FavoritesHeart = void 0;
var _react = require("react");
var _contexts = require("../../contexts");
var _HeartIcon = require("./HeartIcon");
var _jsxRuntime = require("react/jsx-runtime");
const renderHeart = (isInFavorites, onClick) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_HeartIcon.HeartIcon, {
  isFavorite: isInFavorites,
  onClick: onClick
});
const FavoritesHeart = ({
  code,
  productListId,
  render,
  shades
}) => {
  const {
    isProductInList,
    isProductInLists,
    onFavoritesClick,
    toggleProductInLists
  } = (0, _contexts.useFavorites)();
  const isInFavorites = (0, _react.useMemo)(() => productListId ? isProductInList({
    productCode: code,
    productListId
  }) || (shades ?? []).some(({
    productCode
  }) => isProductInList({
    productCode,
    productListId
  })) : isProductInLists(code) || (shades ?? []).some(({
    productCode
  }) => isProductInLists(productCode)), [code, isProductInList, isProductInLists, productListId, shades]);
  const handleClick = (0, _react.useCallback)(event => {
    event.preventDefault();
    event.stopPropagation();
    if (productListId) {
      void toggleProductInLists({
        productCode: code,
        productListIds: [productListId]
      });
    } else {
      onFavoritesClick({
        productCode: code
      });
    }
  }, [code, onFavoritesClick, productListId, toggleProductInLists]);
  const rendered = render?.(renderHeart(isInFavorites), handleClick);
  return rendered ?? renderHeart(isInFavorites, handleClick);
};
exports.FavoritesHeart = FavoritesHeart;
//# sourceMappingURL=FavoritesHeart.js.map